module.exports = __webpack_public_path__ + "static/media/career_banner@768.fb08d312.png";